import axios from '@/plugins/axios'

const BASE = 'volumetria-b2c'

export async function getCotaDiaria() {
  const { data } = await axios.get(`${BASE}/cota-diaria`)
  return data
}

export async function enfileirarVolumetria(body) {
  const { data, status } = await axios.post(`${BASE}/enfileirar`, body)
  return { data, status }
}

export async function getFilaVolumetria(params = {}) {
  const { data } = await axios.get(`${BASE}/fila`, { params })
  return data
}

export async function getPedidoFilaVolumetria(idFila) {
  const { data } = await axios.get(`${BASE}/fila/${encodeURIComponent(idFila)}`)
  return data
}

export async function executarPedidoFilaVolumetria(idFila) {
  const { data } = await axios.post(
    `${BASE}/fila/${encodeURIComponent(idFila)}/executar`,
  )
  return data
}

export async function listarPersonalizadasVolumetria(params = {}) {
  const { data } = await axios.get(`${BASE}/personalizadas`, { params })
  return data
}

export async function criarPersonalizadaVolumetria(body) {
  const { data, status } = await axios.post(`${BASE}/personalizadas`, body)
  return { data, status }
}

export async function atualizarPersonalizadaVolumetria(idPersonalizada, body) {
  const { data } = await axios.patch(
    `${BASE}/personalizadas/${encodeURIComponent(idPersonalizada)}`,
    body,
  )
  return data
}

export async function getOrcamentosVolumetria(params = {}) {
  const { data } = await axios.get(`${BASE}/orcamentos`, { params })
  return data
}

export async function getEstadosVolumetria() {
  const { data } = await axios.get(`${BASE}/estados`)
  return data
}

export async function getCidadesPorEstado(estadoId) {
  const { data } = await axios.get(`${BASE}/estados/${estadoId}/cidades`)
  return data
}

export async function getProfissoesVolumetria() {
  const { data } = await axios.get(`${BASE}/profissoes`)
  return data
}

export async function listarBlacklistsCbo(params = {}) {
  const { data } = await axios.get(`${BASE}/blacklist-cbo`, { params })
  return data
}

export async function salvarBlacklistCbo(body) {
  const { data, status } = await axios.post(`${BASE}/blacklist-cbo`, body)
  return { data, status }
}

export async function excluirBlacklistCbo(id) {
  const { data, status } = await axios.delete(`${BASE}/blacklist-cbo/${id}`)
  return { data, status }
}

export async function listarModelosVolumetria(params = {}) {
  const { data } = await axios.get(`${BASE}/modelos`, { params })
  return data
}

export async function salvarModeloVolumetria(body) {
  const { data, status } = await axios.post(`${BASE}/modelos`, body)
  return { data, status }
}

export async function excluirModeloVolumetria(id) {
  const { data, status } = await axios.delete(`${BASE}/modelos/${id}`)
  return { data, status }
}

/** GET tarifa-leads — unitaryValue Ligdata (service Volumetria). */
export async function getTarifaLeadsVolumetria() {
  const { data } = await axios.get(`${BASE}/tarifa-leads`)
  return data
}

/** POST gerar-leads — reserva leads + debita tarifa Ligdata. */
export async function gerarLeadsVolumetria(body) {
  const { data } = await axios.post(`${BASE}/gerar-leads`, body)
  return data
}

/** POST gerar-csv-leads — monta CSV da extração. */
export async function gerarCsvLeadsVolumetria(body) {
  const { data } = await axios.post(`${BASE}/gerar-csv-leads`, body)
  return data
}

/** GET extracao/:id/download — baixa CSV. */
export async function downloadExtracaoLeadsVolumetria(idExtracao) {
  const response = await axios.get(
    `${BASE}/extracao/${encodeURIComponent(idExtracao)}/download`,
    { responseType: 'blob' },
  )
  return response
}
